import React from "react";
import { directDeepLink, SOURCE_WEBVIEW } from "../../../util";
import "./insight.scss";

function InsightCard({ data }) {
	return (
		<div
			className="InsightCard"
			onClick={() => {
				directDeepLink(data?.url, SOURCE_WEBVIEW, true);
				window.open(data?.url?.paramOne);
			}}
		>
			<img src={data?.image} alt="icon" />
		</div>
	);
}

export default InsightCard;
